/** Option letters for MCQ / EMQ (supports A–H for extended matching). */
export const OPTION_LETTERS = "ABCDEFGH";

export function getOptionLetter(
  answerOption: { letter?: string },
  index: number
): string {
  if (answerOption.letter) {
    return answerOption.letter;
  }
  return OPTION_LETTERS[index] || String(index + 1);
}
